// src/preview.tsx
import * as React from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var PREVIEW_MAX_LENGTH = 150;
var Preview = React.forwardRef(
  ({ children = "", ...props }, forwardedRef) => {
    let text = Array.isArray(children) ? children.join("") : children;
    text = text.substr(0, PREVIEW_MAX_LENGTH);
    return /* @__PURE__ */ jsxs(
      "div",
      {
        ref: forwardedRef,
        id: "__react-email-preview",
        style: {
          display: "none",
          overflow: "hidden",
          lineHeight: "1px",
          opacity: 0,
          maxHeight: 0,
          maxWidth: 0
        },
        ...props,
        children: [
          text,
          renderWhiteSpace(text)
        ]
      }
    );
  }
);
var renderWhiteSpace = (text) => {
  if (text.length >= PREVIEW_MAX_LENGTH) {
    return null;
  }
  const whiteSpaceCodes = "\xA0\u200C\u200B\u200D\u200E\u200F\uFEFF";
  return /* @__PURE__ */ jsx("div", { children: whiteSpaceCodes.repeat(PREVIEW_MAX_LENGTH - text.length) });
};
Preview.displayName = "Preview";
export {
  Preview
};
